module.exports = __webpack_public_path__ + "img/2.c55cadf3.png";